import axiosInstance from '../utils/axios';

/**
 * AI 모델 / 보정 raw 데이터 관리 서비스 (관리자)
 *
 * Phase3 개인화 — 사용자별 AI 모델 업로드/목록 + 보정 raw 데이터 export.
 * BLE V2.0.7+: 모델(mldata.dat) + meta(48B mldata.meta) 패키지.
 * 백엔드: FileController(ai-model) / AppCalibrationController(raw export).
 */
class AiModelService {
  /**
   * 사용자별 AI 모델 목록 (사용자 모델 + 글로벌)
   * @param {number} userIdx
   * @returns {Promise<Object>} { success, data: { items, count } }
   */
  async getList(userIdx) {
    try {
      const response = await axiosInstance.get('/file/ai-model/list', {
        params: { userIdx },
      });
      return response.data;
    } catch (error) {
      console.error('aiModel getList error:', error);
      throw error;
    }
  }

  /**
   * 사용자별 최신 AI 모델
   * @param {number} userIdx
   */
  async getLatest(userIdx) {
    try {
      const response = await axiosInstance.get('/file/ai-model/latest', {
        params: { userIdx },
      });
      return response.data;
    } catch (error) {
      console.error('aiModel getLatest error:', error);
      throw error;
    }
  }

  /**
   * AI 모델+meta 패키지 업로드. version 미지정 시 백엔드가 파일명에서 추출.
   * userIdx 지정 시 사용자별 모델, 생략(null) 시 글로벌(공용) 모델.
   * @param {File} modelFile 모델 바이너리 (mldata.dat 등)
   * @param {File} metaFile AI Meta 48바이트 (mldata.meta)
   * @param {number|null} userIdx
   * @param {string} version 모델 버전(예: 1.0.0). 빈 값이면 파일명 추출.
   */
  async upload(modelFile, metaFile, userIdx = null) {
    try {
      const formData = new FormData();
      formData.append('file_array[]', modelFile);
      formData.append('meta_file', metaFile);
      if (userIdx !== null && userIdx !== undefined && userIdx !== '') {
        formData.append('userIdx', String(userIdx));
      }
      // 버전은 보내지 않는다 — 서버가 업로드 시각으로 라벨을 만든다(식별은 내용 해시)

      const response = await axiosInstance.post('/file/upload/ai-model', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      console.error('aiModel upload error:', error);
      throw error;
    }
  }

  /**
   * 사용자 보정 raw 데이터 export (AI팀 학습 입력)
   * @param {number} userIdx
   * @param {string|null} pairId 특정 pair 만 (없으면 전체)
   * @returns {Promise<Object>} { success, data: { user_idx, count, chunks } }
   */
  async exportRawChunks(userIdx, pairId = null) {
    try {
      const params = { userIdx };
      if (pairId) params.pairId = pairId;
      const response = await axiosInstance.get('/admin/calibration/raw/export', {
        params,
      });
      return response.data;
    } catch (error) {
      console.error('aiModel exportRawChunks error:', error);
      throw error;
    }
  }
}

const aiModelService = new AiModelService();
export default aiModelService;
